function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7097 21.4677C20.2329 21.4677 21.4677 20.2329 21.4677 18.7097C21.4677 17.1864 20.2329 15.9516 18.7097 15.9516C17.1864 15.9516 15.9516 17.1864 15.9516 18.7097C15.9516 20.2329 17.1864 21.4677 18.7097 21.4677Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2903 21.4677C28.8135 21.4677 30.0484 20.2329 30.0484 18.7097C30.0484 17.1864 28.8135 15.9516 27.2903 15.9516C25.7671 15.9516 24.5322 17.1864 24.5322 18.7097C24.5322 20.2329 25.7671 21.4677 27.2903 21.4677Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7097 30.0484C20.2329 30.0484 21.4677 28.8135 21.4677 27.2903C21.4677 25.7671 20.2329 24.5322 18.7097 24.5322C17.1864 24.5322 15.9516 25.7671 15.9516 27.2903C15.9516 28.8135 17.1864 30.0484 18.7097 30.0484Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2903 30.0484C28.8135 30.0484 30.0484 28.8135 30.0484 27.2903C30.0484 25.7671 28.8135 24.5322 27.2903 24.5322C25.7671 24.5322 24.5322 25.7671 24.5322 27.2903C24.5322 28.8135 25.7671 30.0484 27.2903 30.0484Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M4.8172 28.1075C5.26853 28.1075 5.63441 27.7416 5.63441 27.2903C5.63441 26.839 5.26853 26.4731 4.8172 26.4731C4.36587 26.4731 4 26.839 4 27.2903C4 27.7416 4.36587 28.1075 4.8172 28.1075Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M4.8172 19.5268C5.26853 19.5268 5.63441 19.1609 5.63441 18.7096C5.63441 18.2583 5.26853 17.8924 4.8172 17.8924C4.36587 17.8924 4 18.2583 4 18.7096C4 19.1609 4.36587 19.5268 4.8172 19.5268Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1827 28.1075C41.6341 28.1075 41.9999 27.7416 41.9999 27.2903C41.9999 26.839 41.6341 26.4731 41.1827 26.4731C40.7314 26.4731 40.3655 26.839 40.3655 27.2903C40.3655 27.7416 40.7314 28.1075 41.1827 28.1075Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M41.1827 19.5268C41.6341 19.5268 41.9999 19.1609 41.9999 18.7096C41.9999 18.2583 41.6341 17.8924 41.1827 17.8924C40.7314 17.8924 40.3655 18.2583 40.3655 18.7096C40.3655 19.1609 40.7314 19.5268 41.1827 19.5268Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7097 5.63441C19.161 5.63441 19.5269 5.26853 19.5269 4.8172C19.5269 4.36587 19.161 4 18.7097 4C18.2583 4 17.8925 4.36587 17.8925 4.8172C17.8925 5.26853 18.2583 5.63441 18.7097 5.63441Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2903 5.63441C27.7416 5.63441 28.1075 5.26853 28.1075 4.8172C28.1075 4.36587 27.7416 4 27.2903 4C26.839 4 26.4731 4.36587 26.4731 4.8172C26.4731 5.26853 26.839 5.63441 27.2903 5.63441Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7097 42C19.161 42 19.5269 41.6341 19.5269 41.1828C19.5269 40.7315 19.161 40.3656 18.7097 40.3656C18.2583 40.3656 17.8925 40.7315 17.8925 41.1828C17.8925 41.6341 18.2583 42 18.7097 42Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2903 42C27.7416 42 28.1075 41.6341 28.1075 41.1828C28.1075 40.7315 27.7416 40.3656 27.2903 40.3656C26.839 40.3656 26.4731 40.7315 26.4731 41.1828C26.4731 41.6341 26.839 42 27.2903 42Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8441 20.2419C11.6903 20.2419 12.3763 19.5559 12.3763 18.7097C12.3763 17.8634 11.6903 17.1774 10.8441 17.1774C9.99784 17.1774 9.31183 17.8634 9.31183 18.7097C9.31183 19.5559 9.99784 20.2419 10.8441 20.2419Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8441 28.8225C11.6903 28.8225 12.3763 28.1364 12.3763 27.2902C12.3763 26.4439 11.6903 25.7579 10.8441 25.7579C9.99784 25.7579 9.31183 26.4439 9.31183 27.2902C9.31183 28.1364 9.99784 28.8225 10.8441 28.8225Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8441 36.6881C11.6903 36.6881 12.3763 36.0021 12.3763 35.1559C12.3763 34.3096 11.6903 33.6236 10.8441 33.6236C9.99784 33.6236 9.31183 34.3096 9.31183 35.1559C9.31183 36.0021 9.99784 36.6881 10.8441 36.6881Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8441 12.3763C11.6903 12.3763 12.3763 11.6903 12.3763 10.844C12.3763 9.99778 11.6903 9.31177 10.8441 9.31177C9.99784 9.31177 9.31183 9.99778 9.31183 10.844C9.31183 11.6903 9.99784 12.3763 10.8441 12.3763Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1559 20.2419C36.0022 20.2419 36.6882 19.5559 36.6882 18.7097C36.6882 17.8634 36.0022 17.1774 35.1559 17.1774C34.3097 17.1774 33.6237 17.8634 33.6237 18.7097C33.6237 19.5559 34.3097 20.2419 35.1559 20.2419Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1559 28.8225C36.0022 28.8225 36.6882 28.1364 36.6882 27.2902C36.6882 26.4439 36.0022 25.7579 35.1559 25.7579C34.3097 25.7579 33.6237 26.4439 33.6237 27.2902C33.6237 28.1364 34.3097 28.8225 35.1559 28.8225Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1559 36.6881C36.0022 36.6881 36.6882 36.0021 36.6882 35.1559C36.6882 34.3096 36.0022 33.6236 35.1559 33.6236C34.3097 33.6236 33.6237 34.3096 33.6237 35.1559C33.6237 36.0021 34.3097 36.6881 35.1559 36.6881Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M35.1559 12.3763C36.0022 12.3763 36.6882 11.6903 36.6882 10.844C36.6882 9.99778 36.0022 9.31177 35.1559 9.31177C34.3097 9.31177 33.6237 9.99778 33.6237 10.844C33.6237 11.6903 34.3097 12.3763 35.1559 12.3763Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2903 12.3763C28.1366 12.3763 28.8226 11.6903 28.8226 10.844C28.8226 9.99778 28.1366 9.31177 27.2903 9.31177C26.4441 9.31177 25.7581 9.99778 25.7581 10.844C25.7581 11.6903 26.4441 12.3763 27.2903 12.3763Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7097 12.3763C19.5559 12.3763 20.2419 11.6903 20.2419 10.844C20.2419 9.99778 19.5559 9.31177 18.7097 9.31177C17.8634 9.31177 17.1774 9.99778 17.1774 10.844C17.1774 11.6903 17.8634 12.3763 18.7097 12.3763Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2903 36.6881C28.1366 36.6881 28.8226 36.0021 28.8226 35.1559C28.8226 34.3096 28.1366 33.6236 27.2903 33.6236C26.4441 33.6236 25.7581 34.3096 25.7581 35.1559C25.7581 36.0021 26.4441 36.6881 27.2903 36.6881Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M18.7097 36.6881C19.5559 36.6881 20.2419 36.0021 20.2419 35.1559C20.2419 34.3096 19.5559 33.6236 18.7097 33.6236C17.8634 33.6236 17.1774 34.3096 17.1774 35.1559C17.1774 36.0021 17.8634 36.6881 18.7097 36.6881Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});
function SvgBlurryImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurryImg);
export default __webpack_public_path__ + "static/media/blurry-img.0d2046526c88201a4527a58e1f871adb.svg";
export { ForwardRef as ReactComponent };